var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { createTheme as createMuiTheme } from '@mui/material/styles';
import { createBreakpoints } from '@mui/system';
import { createLayout } from './create-layout';
import { createComponents } from './create-components';
import { createMixins } from './create-mixins';
import { createPalette } from './create-palette';
import { createTypography } from './create-typography';
import { auth0 } from '@auth0/quantum-tokens';
var defaultThemeTokens = auth0;
export var createTheme = function (_a) {
    if (_a === void 0) { _a = {}; }
    var layoutOptions = _a.layout, componentsOptions = _a.components, paletteOptions = _a.palette, typographyOptions = _a.typography, _b = _a.breakpoints, breakpointsOptions = _b === void 0 ? {} : _b, tokens = _a.tokens, options = __rest(_a, ["layout", "components", "palette", "typography", "breakpoints", "tokens"]);
    var colorMode = (paletteOptions === null || paletteOptions === void 0 ? void 0 : paletteOptions.mode) || 'light';
    // Ensure we have all global tokens as well. Not exposing global to the consumer at this time.
    var completeThemeTokens = __assign(__assign({}, defaultThemeTokens[colorMode]), tokens);
    var breakpoints = createBreakpoints(breakpointsOptions);
    var baseTheme = createMuiTheme(__assign({ palette: createPalette(paletteOptions, completeThemeTokens), tokens: completeThemeTokens, breakpoints: breakpoints, typography: function (p) {
            return createTypography(typeof typographyOptions === 'function' ? typographyOptions({ palette: p, breakpoints: breakpoints }) : typographyOptions, completeThemeTokens);
        } }, options));
    var mixins = createMixins({
        palette: baseTheme.palette,
        spacing: baseTheme.spacing,
        breakpoints: baseTheme.breakpoints,
        overrides: baseTheme.mixins,
        tokens: completeThemeTokens,
    });
    var layout = createLayout(__assign(__assign({}, layoutOptions), { tokens: completeThemeTokens }));
    var components = createComponents(__assign(__assign({}, baseTheme), { mixins: mixins, layout: layout, components: componentsOptions }));
    var themeOptions = {
        palette: __assign({}, baseTheme.palette),
        typography: baseTheme.typography,
        breakpoints: baseTheme.breakpoints,
        mixins: mixins,
        components: components,
        layout: layout,
        spacingPX: function (factor) { return factor * 8; },
        // flatten this internally to make reference easier
        tokens: completeThemeTokens,
        shadows: __spreadArray([
            'none',
            '0px 2px 4px rgba(0, 0, 0, 0.12)',
            '0px 6px 8px rgba(0, 0, 0, 0.1)',
            '0px 12px 12px rgba(0, 0, 0, 0.1)'
        ], __read(Array.from({ length: 20 }).map(function () { return '0px 16px 16px rgba(0, 0, 0, 0.1)'; })), false),
    };
    var theme = createMuiTheme(themeOptions);
    theme.unsafe_globalTokens = completeThemeTokens;
    return theme;
};
